{
  "manager": {
    "integrationsCard": {
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect {label}",
      "disconnectBody": "Disconnecting removes the active connection and immediately disables its features.",
      "requestDtdAccount": "Request a DTD account",
      "secretSaved": "Saved — enter a new value to replace it.",
      "secretPlaceholder": "Enter a new value to update"
    }
  }
}
